export class GroupSidebarListGroupComponent {
    static $inject = ['$location'];

    public group: any;

    constructor(private $location: angular.ILocationService) {}

    goToGroup() {
        this.$location.url(`/group/${this.group.id}`);
    }
}

angular.module('tradersyard').component('tyGroupSidebarListGroup', {
    template: `
        <div class="group_sidebar_list_group" ng-click="$ctrl.goToGroup()">
          <img ng-src="{{$ctrl.group.picture.source|thumb:45:45}}" alt="" class="group_sidebar_list_group__thumbnail">
          <div class="group_sidebar_list_group__name">
              <a ng-href="/group/{{$ctrl.group.id}}" title="{{$ctrl.group.name}}" ng-bind-html="$ctrl.group.name|highlight : $ctrl.searchHighlight"></a>
          </div>
        </div>
    `,
    bindings: {
        group: '<',
        searchHighlight: '<',
    },
    controller: GroupSidebarListGroupComponent,
});
